// third-party
import { presetPalettes, presetDarkPalettes } from '@ant-design/colors';

// project imports
import ThemeOption from './theme';
import { extendPaletteWithChannels } from 'utils/colorUtils';

const greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
// Hand-picked dark-surface ramp, same 17-slot layout as buildGrey() below
// (0-10 primary ramp, 11-14 ascent, 15-16 constant) so ThemeOption's fixed
// index mapping (src/themes/theme/index.js) produces sane dark tokens:
// slot 0 -> background.paper, slot 15 -> background.default,
// slot 10 -> shadow color only (kept near-black on purpose, see custom-shadows.jsx).
const greyPrimaryDark = [
  '#1a1e27',
  '#20242e',
  '#262b36',
  '#333a47',
  '#454c5b',
  '#5b6373',
  '#8a92a3',
  '#aab1bf',
  '#e3e6ea',
  '#eef0f3',
  '#000000'
];
const greyAscentDark = ['#20242e', '#2a2f3a', '#454c5b', '#5b6373'];
const greyConstantDark = ['#12151b', '#333a47'];

// ==============================|| GREY COLORS BUILDER ||============================== //

function buildGrey() {
  let greyPrimary = [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#262626',
    '#141414',
    '#000000'
  ];
  let greyConstant = ['#fafafb', '#e6ebf1'];

  return [...greyPrimary, ...greyAscent, ...greyConstant];
}

function buildGreyDark() {
  return [...greyPrimaryDark, ...greyAscentDark, ...greyConstantDark];
}

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export function buildPalette(presetColor) {
  const lightColors = { ...presetPalettes, grey: buildGrey() };
  const lightPaletteColor = ThemeOption(lightColors, presetColor);

  const darkColors = { ...presetDarkPalettes, grey: buildGreyDark() };
  const darkPaletteColor = ThemeOption(darkColors, presetColor);

  const commonColor = { common: { black: '#000', white: '#fff' } };

  const extendedLight = extendPaletteWithChannels(lightPaletteColor);
  const extendedDark = extendPaletteWithChannels(darkPaletteColor);
  const extendedCommon = extendPaletteWithChannels(commonColor);

  return {
    light: {
      mode: 'light',
      ...extendedCommon,
      ...extendedLight,
      text: {
        primary: extendedLight.grey[700],
        secondary: extendedLight.grey[500],
        disabled: extendedLight.grey[400]
      },
      action: { disabled: extendedLight.grey[300] },
      divider: extendedLight.grey[200],
      background: {
        paper: extendedLight.grey[0],
        default: extendedLight.grey.A50
      }
    },
    dark: {
      mode: 'dark',
      ...extendedCommon,
      ...extendedDark,
      text: {
        primary: extendedDark.grey[700],
        secondary: extendedDark.grey[500],
        disabled: extendedDark.grey[400]
      },
      action: { disabled: extendedDark.grey[300] },
      divider: extendedDark.grey[200],
      background: {
        paper: extendedDark.grey[0],
        default: extendedDark.grey.A50
      }
    }
  };
}
